import { LanguageDTOLangKeyEnum } from '@ringo/shared'

export function getLangKeyFromI18n(i18nLang: string): LanguageDTOLangKeyEnum {
    if (!i18nLang) {
        return LanguageDTOLangKeyEnum.De
    }
    return i18nLang.toUpperCase() as LanguageDTOLangKeyEnum
}
